import React from 'react'
import SimpleTextField from '../../../../components/Forms/SimpleTextField'
import Grid from '@mui/material/Grid'
const AssessmentText = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12}>
    <SimpleTextField
      value={moduleValues?.['Assessment'] ?? ''}
      onChange={(e) =>
        setModuleValues((prev) => ({
          ...prev,
          ['Assessment']: e.target.value,
        }))
      }
      label="Assessment Notes"
      multiline
      minRows={2}
    />
  </Grid>
)

export default AssessmentText
